/*=========================================================================================
	File Name: moduleAuth.js
	Description: Auth Module
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTemplatesState.js'
import mutations from './moduleTemplatesMutations.js'
import actions from './moduleTemplatesActions.js'
import getters from './moduleTemplatesGetters.js'

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
